import { validateFile } from "../../reducers/fabric/addtocart.validators";
import { ExifData } from "./types/parts";
import EXIF from 'exif-js';
import alertify from '../../../libs/alert'

export const getFileId = (name: string) => {
    let index = name.lastIndexOf(".")
    let extensionIndex = index + 1 ? index:name.length;
    return name.substring(0, extensionIndex)
}

export const getFileName = (url: string) => {
    const uri = decodeURIComponent(url);
    return uri?.split('#')?.shift()?.split('?')?.shift()?.split('/')?.pop() || 'currentImage';
}

export const getAsFile = async (url: string, fileName?: string, withExtension?: boolean): Promise<File> => {

    const blob = await (await fetch(url,{
        cache:'no-store'
    })).blob();

    const name = (withExtension ? fileName : (fileName && (fileName + '.' + blob.type.substring(blob.type.indexOf('/') + 1)))) || getFileName(url);
    return new File([blob], name, {
        type: blob.type
    })
}

export const handleFiles = async (files: File[], isLibImage: boolean): Promise<ExifData[]> => {

    let promises = []
    for (let i = 0; i < files.length; i++) {
        promises.push(fetchExifData(files[i]))
    }

    let images: ExifData[] = await Promise.all(promises)

    const validImages = images.filter(image => validateFile(image.file, isLibImage))

    if (validImages.length === 0) {
        alertify.alert('Error', 'selection could not complete as files were not read. Try with different images', '')
    } else if (validImages.length < images.length) {
        alertify.alert('Error', 'some files were dropped as they could not be read.', '')
    }

    return validImages;
}

export function fetchExifData(file: File): Promise<ExifData> {
    return new Promise((resolve, reject) => {

        var url = window.URL || window.webkitURL

        let img = new Image()
        img.onload = function () {

            const imageContext = this as any;
            EXIF.getData(imageContext, () => {
                let allMetaData = EXIF.getAllTags(imageContext)

                let curResolution = allMetaData.XResolution
                    ? allMetaData.XResolution.valueOf()
                    : 150

                curResolution = curResolution < 150 ? 150 : curResolution
                resolve({
                    src: imageContext.src,
                    width: imageContext.width,
                    height: imageContext.height,
                    partWidth: imageContext.width,
                    curResolution,
                    file,
                    scaleFactor: 1,
                })
            })
        }

        img.src = url.createObjectURL(file)

        img.onerror = function (err) {
            reject(err)
        }

    })
}


